module.exports = __webpack_public_path__ + "static/media/20.e7a960ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/20.jpg
// module id = 553
// module chunks = 0